import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncCoworkTermsOfUse({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/CoworkTermsOfUse"));
  console.log("Loading", AsyncCoworkTermsOfUse.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncCoworkTermsOfUse;
